import Request from "../lib/request";
import { NOTIFICATIONS_API } from "../constants/api";
import { PAGE } from "../constants/filters";

const baseUrl = process.env.REACT_APP_API_URL;

export const get = pageNumber => {
  return Request({
    method: "get",
    url: `${baseUrl}/${NOTIFICATIONS_API}?${PAGE}=${pageNumber}`,
    needToken: true
  });
};

export const action = (id, action) => {
  return Request({
    method: "put",
    url: `${baseUrl}/${NOTIFICATIONS_API}/${id}`,
    needToken: true,
    data: { action: action }
  });
};
